import React, { Component } from 'react';

class Container extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    
    render() {
        let { children, type, position, topBuffer } = this.props;
        return (
            <div 
                className   = {`marketkit-toast ${ type || 'success'} ${ position || 'center top' }`}
                style       = {{ marginTop: topBuffer }}
            >
                { children }
            </div>
        )
    }
}

export default Container;